import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import * as FlatModels from '@medsurf/flat-models';
import { ButtonDirective } from 'primeng/button';

@Component({
    selector: 'button[medsurf-design-input-button], a[medsurf-design-input-button]',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './button.input.design.html',
    styleUrls: ['./button.input.design.scss'],
    hostDirectives: [{
      directive: ButtonDirective,
    }],
    host: { type: 'button', class: 'flex column-gap-1' },
    standalone: false
})
export class ButtonInputDesign {
  @Input() iconClass?: string;
  @Input() iconClassAfter?: string;
  @Input() label?: string;

  @HostBinding('class')
  @Input() inputClass: FlatModels.ButtonDesignModels.ButtonDesignClass = FlatModels.ButtonDesignModels.ButtonDesignClass.PRIMARY;

  @HostBinding('class.justify-content-center') get iconOnly() {
    return !this.label && (this.iconClass || this.iconClassAfter);
  }
}
